import React, { createContext, useState } from 'react';
import i18n from '@/i18n';

const LanguageContext = createContext({
  language: i18n.language,
  switchLanguage: (_lang: string) => {}
});

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(i18n.language);

  const switchLanguage = (lang: string) => setLanguage(lang);

  return <LanguageContext.Provider value={{ language, switchLanguage }}>{children}</LanguageContext.Provider>;
};

export default LanguageContext;
